<script>
import { texts } from "@/language/texts";
export default {
  name: 'ChatWindow',
  props: {
    color: {
      type: String,
      default: "#8B5CF6"
    },
    isShow: {
      type: Boolean,
      default: false
    },
    slug: {
      type: String,
      required: true
    },
    activeColor: {
      type: String,
      default: "#8B5CF6"
    },
    isInline: {
      type: Boolean,
      default: false
    },
    isTest: {
      type: Boolean,
      default: false
    },
    welcomeMessage: {
      type: String,
      default: 'Я всегда на связи и готов ответить! Чем я могу вам помочь?'
    },
    dataPolicyUrl: {
      type: String,
      default: ''
    },
    dataPolicyLinkText: {
      type: String,
      default: ''
    },
    contactDataType: {
      type: String,
      default: 'email'
    },
    assistantName: {
      type: String,
      default: 'Андрей Ботаев'
    },
    assistantAvatar: {
      type: String,
      default: '@/assets/avatar.svg'
    },
    language: {
      type: String,
      default: 'ru'
    },
    isGuestMode: {
      type: Boolean,
      default: false
    },
    guestEmail: {
      type: String,
    },
    guestName: {
      type: String,
    },
    messagesList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      userData: {
        email: null,
        phone: null,
        name: null
      },
      messageToSend: null,
      inputMessage: null,
      inputMessageLoading: null,
      showUserForm: false,
      messages: [],
      errors: {
        message: false,
        email: false,
        phone: false,
        name: false
      },
      textLines: texts[this.language],
      sourceUrl: '',
    }
  },
  async mounted() {
    const userData = localStorage.getItem('userData');
    if (userData) {
      this.userData = JSON.parse(userData);
    }

    this.sourceUrl = window.location.href;

    if (this.messagesList) {
      // Преобразовывем сообщения в нужный формат
      this.messages = await Promise.all(this.messagesList.map(async (msg) => {
        let isImage = false;
        if (msg.text.startsWith('http')) {
          isImage = await this.isImageUrl(msg.text);
        }

        let isUrl = false;
        if (msg.text.startsWith('http')) {
          isUrl = this.isTextUrl(msg.text);
        }

        const dateParts = msg.date.split('.');
        const dateObject = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`); // Форматируем в "YYYY-MM-DD"

        return {
          type: msg.is_from_bot === 0 ? 'user' : 'assistant', // Пример, проверьте ваш формат
          message: msg.text,
          isImage: isImage,
          isUrl: isUrl,
          date: dateObject // Используем объект Date
        };
      }));
    }
  },
  watch: {
    isShow() {
      if (this.isShow) {
        this.$nextTick(() => {
          this.$refs.message.focus();
          this.scrollToBottom();
        })
      }
    },
    language() {
      this.textLines = texts[this.language];
      this.$nextTick(() => {
        this.scrollToBottom();
      })
    }
  },
  methods: {
    showTypingIndicator() {
      const typingElement = this.$refs.typing;
      typingElement.style.display = 'block';
      setTimeout(() => {
        typingElement.style.display = 'none';
      }, 2000);
    },
    uuidv4() {
      return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
          (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
      );
    },
    async isImageUrl(url) {
      try {
        const img = new Image();
        return await new Promise((resolve) => {
          img.onload = () => resolve(true);
          img.onerror = () => resolve(false);
          img.src = url;
        });
      } catch (error) {
        console.error("Error while validating image URL:", error);
        return false;
      }
    },
    isTextUrl(url) {
      const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
      return urlPattern.test(url);
    },
    handleEnterPress(event) {
      if (!this.inputMessage) {
        return; // Не отправляем, если поле пустое
      }
      this.sendMessage(); // Вызываем метод отправки сообщения
      event.preventDefault(); // Останавливаем стандартное поведение
    },
    async sendMessage() {
      this.errors = {message: false, email: false, phone: false, name: false};
      if (this.inputMessage) this.messageToSend = this.inputMessage;
      this.inputMessageLoading = true;

      if(this.isTest) {
        this.userData.email = 'test@lampabot.ru';
        this.userData.name = 'Пользователь';
        if(!localStorage.getItem('uid')) {
          localStorage.setItem('userData', JSON.stringify(this.userData));
          localStorage.setItem('uid', this.uuidv4());
        }
      }

      console.log('isGuestMode:', this.isGuestMode);
      console.log('guestEmail:', this.guestEmail);
      console.log('guestName:', this.guestName);

      if(this.isGuestMode) {
        this.userData.email = this.guestEmail;
        this.userData.name = this.guestName;
        if(!localStorage.getItem('uid')) {
          localStorage.setItem('userData', JSON.stringify(this.userData));
          localStorage.setItem('uid', this.uuidv4());
        }
      }

      if (!this.showUserForm) {
        if (!this.messageToSend) {
          this.errors.message = true;
          return;
        }
      } else {
        if (!this.userData.name) {
          this.errors.name = true;
          return;
        }

        if (this.contactDataType === 'email') {
          if (!this.userData.email || !this.isValidEmail(this.userData.email)) {
            this.errors.email = true;
            return;
          }
        } else if (this.contactDataType === 'phone') {
          if (!this.userData.phone || !this.isValidPhone(this.userData.phone)) {
            this.errors.phone = true;
            return;
          }
        }
        localStorage.setItem('userData', JSON.stringify(this.userData));
        localStorage.setItem('uid', this.uuidv4());
      }

      this.inputMessage = null;
      this.inputMessageLoading = false;
      if ((this.userData.email || this.userData.phone) && this.userData.name && this.messageToSend) {
        this.showUserForm = false;
        let isImage = false;
        if (this.messageToSend.startsWith('http')) {
          isImage = await this.isImageUrl(this.messageToSend);
        }
        let isUrl = false;
        if (this.messageToSend.startsWith('http')) {
          isUrl = this.isTextUrl(this.messageToSend);
        }
        this.messages.push({
          type: 'user',
          message: this.messageToSend,
          isImage: isImage,
          isUrl: isUrl,
          date: new Date()
        })
        localStorage.setItem('messages', JSON.stringify(this.messages));
        this.$nextTick(() => {
          this.scrollToBottom();
        })
        await this.sendMessageRequest(this.messageToSend, this.userData.email, this.userData.phone, this.userData.name);
        this.messageToSend = null;
      } else {
        this.showUserForm = true
        this.$nextTick(() => {
          this.$refs.name.focus();
        })
      }
    },
    async sendMessageRequest(message, email, phone, sender) {
      const uuid = localStorage.getItem('uid');
      const contact_data = email ?? phone;
      const data = {message, contact_data, sender, uuid, source_url: this.sourceUrl};

      try {
        const response = await fetch(process.env.VUE_APP_API_URL + this.slug, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

      } catch (error) {
        console.error('Error sending message:', error);
      }
    },
    isValidEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    },
    isValidPhone(phone) {
      const phonePattern = /^\+?([1-9]\d{0,2})[1-9]\d{6,11}$/;
      return phonePattern.test(phone);
    },
    getTransparencyBackground(color) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);

      return `background-color: rgba(${r}, ${g}, ${b}, 0.15)`;
    },
    getColorWithTransparency(color, transparency = 0.6) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);

      return `rgba(${r}, ${g}, ${b}, ${transparency})`;
    },
    isSameSenderAsPrevious(index) {
      if (index === 0) return false;
      return this.messages[index].type === this.messages[index - 1].type;
    },
    isSameDayAsPrevious(index) {
      if (index === 0) return false;
      const previousDate = new Date(this.messages[index - 1].date);
      const currentDate = new Date(this.messages[index].date);

      return previousDate.getFullYear() === currentDate.getFullYear() &&
          previousDate.getMonth() === currentDate.getMonth() &&
          previousDate.getDate() === currentDate.getDate();
    },
    messageFromAssistant(message) {
      const typingElement = this.$refs.typing;
      typingElement.style.display = 'none';
      this.messages.push({
        type: 'assistant',
        message,
        date: new Date()
      });
      localStorage.setItem('messages', JSON.stringify(this.messages));
      this.$nextTick(() => {
        this.scrollToBottom();
      })
    },
    scrollToBottom() {
      const container = this.$refs.chatWindow;
      container.scrollTop = container.scrollHeight;
    },
    formatMessage(message) {
      let formattedMessage = message;

      // Регулярные выражения для изображений, markdown ссылок [link](url) и стандартных ссылок
      const markdownLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/gi;
      const imageRegex = /(https?:\/\/.*\.(?:png|jpg|jpeg|gif|svg))/gi;
      const linkRegex = /(https?:\/\/(?!.*\.(?:png|jpg|jpeg|gif|svg))[^\s]+)/gi;

      // Markdown-ссылки
      const markdownMatches = [];
      formattedMessage = formattedMessage.replace(markdownLinkRegex, (_, text, url) => {
        const placeholder = `__MARKDOWN_LINK_${markdownMatches.length}__`;
        markdownMatches.push(`<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`);
        return placeholder;
      });

      // Ссылки на изображения
      formattedMessage = formattedMessage.replace(imageRegex, (match) =>
          `<img src="${match}" alt="Image" style="max-width: 100%; height: auto;">`
      );

      // Обычные ссылки
      formattedMessage = formattedMessage.replace(linkRegex, (match) =>
          `<a href="${match}" target="_blank" rel="noopener noreferrer" style="word-break: break-all;">${match}</a>`
      );

      // Вставляем markdown обратно
      markdownMatches.forEach((html, i) => {
        formattedMessage = formattedMessage.replace(`__MARKDOWN_LINK_${i}__`, html);
      });

      return formattedMessage;
    }
  }
}
</script>

<template>
  <transition name="chat-window-pulse">
    <div class="chat-component" :class="!isInline ? 'bottom-chat' : ''" v-show="isShow">
      <div class="online-chat position-relative z-1" :style="isTest ? 'border: 0; max-width: initial;' : ''">
        <div class="chat-content" :style="isTest ? 'box-shadow: initial;' : ''">
          <div class="chat-title" v-if="!isTest">
            {{ textLines['online-chat'] }}
          </div>
          <div class="chat-title" v-else>
            Тестирование чат-бота
          </div>
          <div class="chat-window" ref="chatWindow">
            <div class="welcome-message d-flex">
              <div class="avatar" :style="'background: url(\'' + assistantAvatar +'\') top center'"></div>
              <div class="message-data">
                <div class="bot-message">
                  <div class="d-flex align-items-center">
                    <div class="online-status"></div>
                    <div class="name">{{ assistantName }}</div>
                  </div>
                  <div class="message-box" v-html="formatMessage(welcomeMessage)"></div>
                </div>
                <div v-if="showUserForm" class="user-form message-box">
                  <div class="name">{{ textLines['show-contacts-data'] }}</div>
                  <div class="input-container">
                    <div>
                      <input type="text" class="chat-input" :placeholder="textLines['enter-your-name']" v-model="userData.name" :class="errors.name ? 'red-focus' : ''" ref="name" @keydown.enter.stop="sendMessage"/>
                    </div>
                    <div v-if="contactDataType === 'email'" class="mt-10">
                      <input type="text" class="chat-input" :placeholder="textLines['enter-your-email']" v-model="userData.email" :class="errors.email ? 'red-focus' : ''" @keydown.enter.stop="sendMessage"/>
                    </div>
                    <div v-if="contactDataType === 'phone'" class="mt-10">
                      <input type="text" class="chat-input" :placeholder="textLines['enter-your-phone']" v-model="userData.phone" :class="errors.phone ? 'red-focus' : ''" @keydown.enter.stop="sendMessage"/>
                    </div>
                    <button class="btn violet-button mt-10 ms-0" @click.stop="sendMessage"><span>{{ textLines['send'] }}</span></button>
                  </div>
                  <div v-if="dataPolicyUrl && dataPolicyLinkText" class="mt-10">
                      <a :href="dataPolicyUrl" target="_blank" rel="noopener noreferrer" class="small-text" :style="{ color: getColorWithTransparency(color, 0.6) }">{{ dataPolicyLinkText }}</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="messages">
              <div v-for="(message, index) in messages" :key="index">
                <div v-if="!isSameDayAsPrevious(index) || index === 0">
                  <div class="date-divider">{{ new Date(message.date).toLocaleDateString() }}</div>
                </div>
                <div :class="message.type === 'user' ? 'user-message' : 'bot-message'" class="d-flex">
                  <div class="avatar" v-if="message.type !== 'user'"  :style="'background: url(\'' + assistantAvatar +'\')'"></div>
                  <div class="message-data">
                    <div v-if="message.type === 'user'">
                      <div class="name" v-if="!isSameSenderAsPrevious(index)">{{ userData.name }}</div>
                      <div v-if="message.isImage" class="message-box" :style="getTransparencyBackground(color)">
                        <img :src="message.message" alt="User sent image" style="max-width: 100%; height: auto;" />
                      </div>
                      <div v-else-if="message.isUrl" class="message-box" :style="getTransparencyBackground(color)">
                        <a :href="message.message" target="_blank" rel="noopener noreferrer">{{ message.message }}</a>
                      </div>
                      <div v-else class="message-box" :style="getTransparencyBackground(color)" v-html="formatMessage(message.message)">
                      </div>
                    </div>
                    <div v-else>
                      <div class="d-flex align-items-center">
                        <div class="online-status"></div>
                        <div class="name">{{ assistantName }}</div>
                      </div>
                      <div class="message-box" v-html="formatMessage(message.message)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="typing" ref="typing" v-if="textLines && textLines['agent-is-typing']">{{ textLines['agent-is-typing'] }}</div>
          <div class="chat-actions" :class="showUserForm ? 'disabled' : ''">
            <input type="text" :placeholder="textLines['enter-message']" v-model="inputMessage" :disabled="showUserForm" @keydown.enter.stop="handleEnterPress" :class="errors.message ? 'red-focus' : ''" ref="message">
            <button class="btn violet-button" @click.stop="sendMessage" :disabled="showUserForm || inputMessage == null || inputMessageLoading"><span>{{ textLines['send'] }}</span></button>
          </div>
        </div>
      </div>
      <div class="bottom-shadow" v-if="!isTest"></div>
    </div>
  </transition>
</template>

<style scoped>
.online-chat {
  color: #242424;
  font-family: 'Roboto', sans-serif;
  border-radius: 24px;
  border: 16px solid rgba(255, 255, 255, .3);
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}

.chat-content {
  overflow: hidden;
  border-radius: 8px;
  box-sizing: border-box;
  position: relative;
  background-clip: padding-box;
  background-color: white;
  box-shadow: 0 0 44px 0px rgba(0, 0, 0, 0.25);
}

.chat-content:before {
  content: "";
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: -1;
  background-image: linear-gradient(180.00deg, rgb(139, 92, 246), rgb(252, 195, 48));
  border-radius: 8px;
}

.typing {
  position: absolute;
  color: v-bind('color');
  opacity: 0.6;
  font-size: 12px;
  margin-top: -25px;
  margin-left: 25px;
  display: none;
}

.chat-title {
  padding: 15px 20px;
  background-color: v-bind('color');
  color: #fff;
  font-size: 16px;
  box-shadow: 0 4px 25.4px 0 rgba(0, 0, 0, 0.25);
  position: relative;
}

.chat-window {
  height: 400px;
  overflow-y: auto;
  padding: 30px;
  background-color: #fff;
}

.d-flex {
  display: flex;
}

.chat-actions {
  box-sizing: border-box;
  border: 1px solid rgb(242, 242, 242);
  box-shadow: 0 -4px 81.8px 0 rgba(0, 0, 0, 0.09);
  background: rgb(255, 255, 255);
  padding: 11px 12px;
  display: flex;
  align-items: center;
}

.chat-actions input, .input-container input {
  box-sizing: border-box;
  border: 1px solid rgb(222, 222, 222);
  border-radius: 7px;
  background: rgb(255, 255, 255);
  height: 36px;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 16px;
  color: #555;
}

.red-focus {
  border-color: #FF0000 !important;
}

.chat-actions .btn, .input-container button {
  height: 36px;
  padding: 6px 12px;
  margin-left: 12px;
}

.violet-button {
  border-radius: 5px;
  background: v-bind('color');
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  padding: 15px 20px;
  color: #fff;
  border: 0;
  cursor: pointer;
}

.avatar {
  border: 4px solid v-bind('color');
  border-radius: 50%;
  box-shadow: inset 4px 4px 4px 0px rgba(0, 0, 0, 0.5);
  width: 62px;
  height: 62px;
  overflow: hidden;
  background-size: cover !important;
}

.avatar img {
}

.online-status {
  width: 12px;
  height: 12px;
  background-color: #8CECA7;
  border-radius: 50%;
  margin-right: 10px;
}

.name {
  font-size: 16px;
  font-weight: 700;
  color: #242424;
}

.message-data {
  margin-left: 24px;
}

.violet-button:hover {
  background: v-bind('activeColor');
  color: #fff;
}

.violet-button span {
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.5);
}

.message-box {
  background-color: #F3F3F3;
  padding: 15px 15px;
  margin-top: 10px;
  line-height: 20px;
  max-width: 320px;
  border-radius: 13px;
  white-space: pre-line
}

.align-items-center {
  align-items: center;
}

.user-form {
  margin-top: 20px;
  line-height: 22px;
}

.input-container {
  margin-top: 10px;
}

.bot-message {
  margin-bottom: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.ms-0 {
  margin-left: 0 !important
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.disabled input, .disabled button {
  cursor: not-allowed;
}

input:focus {
  outline-color: v-bind('color') !important;
}

.bottom-shadow {
  filter: blur(120px);
  background: rgb(0, 0, 0);
  opacity: 0.15;
  max-width: 484px;
  width: 100%;
  height: 142px;
  position: absolute;
  left: 50%;
  margin-top: -90px;
  transform: translateX(-50%);
}

.position-relative {
  position: relative;
}

.z-1 {
  z-index: 1;
}

.messages {
  margin-top: 20px;
}

.user-message {
  justify-content: flex-end;
  margin-bottom: 25px;
}

.user-message .name {
  text-align: right;
}

.small-text {
  font-size: 10px;
  line-height: 1;
  text-decoration: none; /* Убираем подчеркивание по умолчанию */
}

.small-text:hover {
  text-decoration: underline; /* Подчеркивание при наведении */
}

.date-divider {
  text-align: center;
  color: #888;
  font-size: 12px;
  padding: 15px;
}

.bottom-chat {
  position: fixed;
  z-index: 10;
  bottom: 100px;
  right: 20px;
}

.avatar img {
  width: 60px;
}

@media (max-width: 768px) {
  .message-box {
    max-width: 183px;
  }
}

/* Анимация */
.chat-window-pulse-enter-active {
  animation: pulse-in 0.4s ease;
}

.chat-window-pulse-leave-active {
  animation: pulse-out 0.3s ease;
}

@keyframes pulse-in {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

@keyframes pulse-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}
</style>
